import BaseModel from "../base/BaseModel.model";

export default class IndicatorGroup extends BaseModel {

    public name: string | null = null;
  

  
    
    constructor(){
        super();
        this.init();
    }

    init(){
        this.name = null;
    }
}